import BottomNav from "../../components/BottomNav";
import UserPageHeader from "../../components/UserPageHeader";
import Collapsible from "../../components/Collapsible";

export default function UserGuide() {
  return (
    <div className="user-app">
      <BottomNav />
      <div className="user-app-main">
        <UserPageHeader backTo="/dashboard" backLabel="Dashboard" />
        <div className="page">
          <div className="brand-header">
            <span className="brand-logo">📖</span>
            <span className="brand-name">User Guide</span>
            <p className="brand-tagline">Everything you need to know to send a delivery with FastSend</p>
          </div>

          <Collapsible title="📦 Placing an Order" defaultOpen className="delivery-card">
            <p className="hint" style={{ marginBottom: "8px" }}>
              From "Send Package", enter a pickup and drop-off address (search-as-you-type), choose a
              vehicle type, and describe your package:
            </p>
            <ul style={{ paddingLeft: "18px", fontSize: "14px", color: "var(--text-secondary)", lineHeight: 1.7 }}>
              <li><strong>🏍️ Bike</strong> — the default option for most everyday deliveries.</li>
              <li><strong>🚐 Van</strong> — bigger loads, multiple items.</li>
              <li><strong>🚚 Truck</strong> — heavy/industrial cargo, quoted on request rather than an instant price — our team confirms pricing and dispatch after you submit.</li>
            </ul>
            <p className="hint" style={{ marginTop: "8px" }}>
              📌 If your package is under 10kg and the delivery is within 10km, your Bike order might be
              matched to a <strong>bicycle</strong> dispatcher instead of a motorcycle — same price, same
              tracking and verification, just a different (and greener) ride. There's nothing to choose
              for this — it happens automatically when it's a good fit.
            </p>
            <p className="hint" style={{ marginTop: "8px" }}>
              You can also add up to a few intermediate stops, attach a package photo, and choose to
              request it <strong>now</strong> or <strong>schedule</strong> it for a future date/time.
            </p>
          </Collapsible>

          <Collapsible title="💳 Paying for a Delivery" className="delivery-card">
            <p className="hint">Choose at checkout:</p>
            <ul style={{ paddingLeft: "18px", fontSize: "14px", color: "var(--text-secondary)", lineHeight: 1.7 }}>
              <li><strong>Wallet</strong> — instant, and gets a small discount versus other methods.</li>
              <li><strong>Card (Paystack/Flutterwave)</strong> — pay online, redirected back once confirmed.</li>
              <li><strong>Cash</strong> — pay your dispatcher directly on delivery.</li>
            </ul>
            <p className="hint" style={{ marginTop: "8px" }}>
              Top up your wallet any time from the Wallet tab. <strong>FASTSEND Plus</strong> and the{" "}
              <strong>Saver</strong> plan (under Subscription) both give you discounted rates on a
              monthly basis if you ship often.
            </p>
          </Collapsible>

          <Collapsible title="🔎 Tracking & Delivery Verification" className="delivery-card">
            <p className="hint">
              Once a dispatcher accepts your order, tap it from "My Orders" to see them move live on
              the map, with their name, rating, and phone number.
            </p>
            <p className="hint" style={{ marginTop: "8px" }}>
              Every order gets a <strong>verification code</strong> — share it with your dispatcher or
              the receiver at handoff. If you added paid <strong>Receiver Acknowledgement</strong> at
              checkout, delivery instead confirms via a signature, photo, or ID photo depending on
              which method you chose.
            </p>
          </Collapsible>

          <Collapsible title="📜 Order History & Cancelling" className="delivery-card">
            <p className="hint">
              "My Orders" lists everything you've booked with live status. You can cancel an order
              before it's picked up, and rate your dispatcher once it's delivered.
            </p>
          </Collapsible>

          <Collapsible title="🏢 Businesses — Agent, Fleet Owner, B2B, Corporate" className="delivery-card">
            <p className="hint" style={{ marginBottom: "8px" }}>
              From the "Business" tab, you can apply for any of these — an admin reviews and approves
              each one independently, so you can hold more than one at a time:
            </p>
            <ul style={{ paddingLeft: "18px", fontSize: "14px", color: "var(--text-secondary)", lineHeight: 1.7 }}>
              <li><strong>Agent</strong> — book on behalf of walk-in customers (e.g. a shop taking in packages); a small service fee is already built into the price shown.</li>
              <li><strong>Fleet Owner</strong> — run several dispatchers under one login with a rollup view of their jobs and earnings.</li>
              <li><strong>B2B / Partner</strong> — programmatic API access for integrations that need to submit orders automatically.</li>
              <li><strong>Corporate</strong> — a registered company that books through the app like any customer, but gets billed to a consolidated monthly invoice instead of paying per order — with one-off, scheduled, and recurring standing-order booking built into its own dashboard.</li>
            </ul>
          </Collapsible>

          <Collapsible title="👤 Profile & Saved Info" className="delivery-card">
            <p className="hint">
              Update your name/phone/email, save frequent addresses and contacts for faster checkout,
              and set a preferred dispatcher from your Profile page.
            </p>
          </Collapsible>
        </div>
      </div>
    </div>
  );
}
